import { BarcodeScanner } from '@capacitor-mlkit/barcode-scanning';
import { isPlatform } from '@ionic/react';
import { useEffect, useState } from 'react';
import { runInBackground } from '../../util/async';
import { logger } from '../../util/logger';

const useIsBarcodeScannerSupported = (): boolean => {
  const [isSupported, setIsSupported] = useState(false);

  useEffect(() => {
    runInBackground(async () => {
      try {
        const result = await isBarcodeScannerSupported();
        setIsSupported(result);
      } catch (error) {
        logger.error('Failed to check if barcode scanner is supported', {
          error,
        });
      }
    });
  }, []);

  return isSupported;
};

const isBarcodeScannerSupported = async (): Promise<boolean> => {
  if (!isPlatform('capacitor') || !isPlatform('ios')) {
    return false;
  }

  const { supported } = await BarcodeScanner.isSupported();

  return supported;
};

export { useIsBarcodeScannerSupported };
